export default __webpack_public_path__ + "static/media/banner.93e389ec.jpg";